<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'user-load-pallets-orders'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
  <div style="margin-top: 1em">
    <div class="card">
        <div class="header-card">
          <div class="container-title">
            <!--
              <button (click)="goToLoadsPage()" class="btn-circle bg-yellow" style="margin-right:1em" >
                <i class="pi pi-arrow-left"></i>
              </button>
            -->
            <h2 class="title-main">{{'UserPages.UserLoadPalletsOrders.PageTitle' | translate}}</h2>
          </div>
          <div class="col-12 md:col-6 p-fluid flex align-items-center">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input type="text" pInputText placeholder="{{'UserPages.UserLoadOrders.SearchProducts' | translate}}" class="p-inputtext-sm"  [(ngModel)]="searchTerm" (input)="filterLoads()" />
            </span>
          </div>
          <div>
          </div>
        </div>
      <div class="body-card">
        <div class="subtitle-container">
          <h4 class="subtitle">
            {{'UserPages.UserLoadPalletsOrders.Exporter' | translate}}
          </h4>
          <button type="button" pButton pRipple
            icon="pi pi-file-excel"
            class="p-button-success mr-2 button-success-style"
            pTooltip="XLS"
            (click)="downloadExcelMaster()"
            [loading]="loading"
            tooltipPosition="bottom"
            [style]="{'width':'fit-content', 'margin-left': '2px'}">{{ 'UserPages.UserLoadOrders.ExportExcel' | translate }}
          </button>
        </div>
        <div class="container-filters filters-size">
          <section class="section-info" *ngIf="profile">
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-user" style="margin-right:.5em; color:grey"></i>
                {{companyName}}
              </section>
              <section class="section-data">
                <i class="pi pi-at" style="margin-right:.5em; color:grey"></i>
                {{profile.contactEmail}}
              </section>
            </section>
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-map-marker" style="margin-right:.5em; color:grey"></i>
                {{profile.contactAddress}}
              </section>
              <section class="section-data">
                <i class="pi pi-phone" style="margin-right:.5em; color:grey"></i>
                {{profile.contactPhone}}
              </section>
            </section>
          </section>

          <div class="section-filters">
            <div class="grid-filters">
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="container-filter"
                    [options]="containerFilter"
                    (onChange)="changeFilter()"
                    [(ngModel)]="selectedContainers"
                    optionValue="value"
                    optionLabel="label"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="container-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.containerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="week-filter"
                    [options]="weekFilter"
                    [(ngModel)]="selectedWeeks"
                    (onChange)="changeFilter()"
                    [filter]="true"
                    [showClear]="false"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="week-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.weekFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="importer-filter"
                    [options]="importerFilter"
                    [(ngModel)]="selectedCompanies"
                    (onChange)="changeFilter()"
                    [filter]="true"
                    [(ngModel)]="selectedCompanies"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="importer-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.importerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="specie-filter"
                    [options]="specieFilter"
                    [(ngModel)]="selectedSpecies"
                    (onChange)="changeFilter()"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="specie-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.specieFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="variety-filter"
                    [options]="varietyFilter"
                    [(ngModel)]="selectedVarieties"
                    (onChange)="changeFilter()"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="variety-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.varietyFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="ship-filter"
                    [options]="shipFilter"
                    [(ngModel)]="selectedShip"
                    (onChange)="changeFilter()"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="ship-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.naveFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="program-filter"
                    [options]="numberProgramsFilter"
                    [filter]="true"
                    [(ngModel)]="selectedPrograms"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="program-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.programFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="transport-filter"
                    [options]="transportSelect"
                    [optionLabel]="this.lang == 'es' ? 'nameEs' : 'nameEn'"
                    optionValue="value"
                    (onChange)="changeFilter()"
                    [filter]="true"
                    [showClear]="false"
                    [(ngModel)]="selectedTransportTypes"
                    class="multiselect"
                  />
                  <label for="transport-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.transportFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                  id="year-filter"
                  [options]="years"
                  [(ngModel)]="yearSelect"
                  class="multiselect"
                  [selectionLimit]="1"
                  (onChange)="changeFilter()"
                  placeholder="{{'MyLoadFilter.SelectYear' | translate}}"
                  >
                  </p-multiSelect>
                  <label for="year-filter">
                    {{'MyLoadFilter.YearLabel' | translate}}
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="container-table">
          <div  class="section-table">
            <p-table
              #loadPalletsTable
              [value]="palletLoads"
              dataKey="product.id"
              [loading]="loading"
              [paginator]="true"
              [rows]="100"
              [rowsPerPageOptions]="[100, 200, 500, 1000]"
              [scrollable]="true"
              [resizableColumns]="true"
              columnResizeMode="expand"
              [lazy]="true"
              [totalRecords]="totalCount"
              scrollHeight="800px"
              (onLazyLoad)="loadPalletPage($event)"
              [tableStyle]="{ 'min-width': '50rem' }"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Mostrando desde {first} hasta {last} de {totalRecords} resultados"
              styleClass="p-datatable-gridlines">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ProgramOrderIdHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ProgramName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ImportOrderIdHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TransportTypeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VesselType' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.WeeksHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ShippingCompany' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DepartureCountry' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ETD' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ArrivalPort' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ETA' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ContainerNumberHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Hatch' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ReceiverName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ConsigneeName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VesselName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ArrivalCountry' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.FolioHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PalletBaseName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PalletHeight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TemptaleHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TemperaturePallet' | translate }}</th>
                  <th>CSP</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CspSiteName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledGrowerCSG' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledGrowerName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Commune' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Area' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.District' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.SpecieHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledVarietyName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackagingHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackingDateHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackageNetWeight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackageGrossWeight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabelHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CategoryName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.SpeciesSizeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledSizeName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ColorName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GradeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TreatmentName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Cases' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackingSiteName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PluCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.InspectionType' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DispatchType' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ExporterInstructive' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DestinationPlantName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ArrivalContinent' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.QualityControlDateHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.BookingNoHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DUS' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OriginAirport' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DestinationAirport' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Ref1' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OriginCountryHeader' | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.directSaleProgramId.toString() }}</td>
                  <td>{{ product.programName }}</td>
                  <td>{{ product.importOrderId  }}</td>
                  <td>{{ product.transportType | transportName }}</td>
                  <td>{{ product.vesselType }}</td>
                  <td>{{ product.week }}</td>
                  <td>{{ product.ShippingCompany }}</td>
                  <td>{{ product.departureCountry }}</td>
                  <td>{{ product?.etd | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.destinationPortName }}</td>
                  <td>{{ product?.eta | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.containerNumber }}</td>
                  <td>{{ product?.hatch }}</td>
                  <td>{{ product?.receiverName }}</td>
                  <td>{{ product?.consigneeCompanyName }}</td>
                  <td>{{ product?.ship }}</td>
                  <td>{{ product?.arrivalCountry }}</td>
                  <td>{{ product.palletNumber }}</td>
                  <td>{{ product.palletBaseName }}</td>
                  <td>{{ product.palletHeight }}</td>
                  <td>{{ product.temptale }}</td>
                  <td>{{ product.temperature }}</td>
                  <td>{{ product.csp }}</td>
                  <td>{{ product.packingSiteName }}</td>
                  <td>{{ product.labeledGrowerCSG }}</td>
                  <td>{{ product.labeledGrowerName }}</td>
                  <td>{{ product.commune }}</td>
                  <td>{{ product.area }}</td>
                  <td>{{ product.district }}</td>
                  <td>{{ product.excelImportSpecies }}</td>
                  <td>{{ product.labeledVarietyName }}</td>
                  <td>{{ product.packaging }}</td>
                  <td>{{ product.harvestDate }}</td>
                  <td>{{ product.netKilos }}</td>
                  <td>{{ product.grossWeight }}</td>
                  <td>{{ product.excelImportTag }}</td>
                  <td>{{ product.category }}</td>
                  <td>{{ product.speciesSize }}</td>
                  <td>{{ product.labeledSizeName }}</td>
                  <td>{{ product.colorName }}</td>
                  <td>{{ product.grade }}</td>
                  <td>{{ product.treatmentName }}</td>
                  <td>{{ product.cases }}</td>
                  <td>{{ product.siteNameCsp }}</td>
                  <td>{{ product.pluCode }}</td>
                  <td>{{ product.inspectionType }}</td>
                  <td>{{ product?.dispatchType }}</td>
                  <td>{{ product?.exporterInstructive }}</td>
                  <td>{{ product?.excelImportFridgeStorage }}</td>
                  <td>{{ product?.arrivalContinent }}</td>
                  <td>{{ product?.qualityControlDate | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product?.booking }}</td>
                  <td>{{product?.dus}}</td>
                  <td>{{ product?.departureAirport }}</td>
                  <td>{{ product?.destinationAirport }}</td>
                  <td>{{ product?.ref1 }}</td>
                  <td>{{ product.OriginCountry}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-user-dashboard>
